import type { CanvasPosition } from '../../../../types/infrastructure-map'

export const TREE_LINE_COLOR = 'rgb(100, 116, 139)'
export const PARENT_FILL_COLOR = 'rgb(217, 70, 239)'
export const CONNECTION_POINT_RADIUS = 5
export const TREE_LINE_WIDTH = 3
export const DROP_LINE_WIDTH = 2
export const BRANCH_LINE_OFFSET = 60
export const BRANCH_PADDING_X = 20
export const HOVER_HIT_RADIUS = 20
export const CONNECTION_STROKE_WIDTH = 2

export interface TreeNode {
  endpointId: string
  position: CanvasPosition
  parentId: string | null
  hasChildren: boolean
  childCount: number
  isCollapsed: boolean
}

export interface BranchLine {
  parentId: string
  parentPosition: CanvasPosition
  branchY: number
  children: TreeNode[]
  minX: number
  maxX: number
  childCount: number
  isCollapsed: boolean
}

function groupChildrenByParent(nodes: TreeNode[]): Map<string | null, TreeNode[]> {
  const childrenByParent = new Map<string | null, TreeNode[]>()
  for (const node of nodes) {
    const siblings = childrenByParent.get(node.parentId) ?? []
    siblings.push(node)
    childrenByParent.set(node.parentId, siblings)
  }
  return childrenByParent
}

function buildBranchLine(node: TreeNode, children: TreeNode[]): BranchLine {
  const allXPositions = [node.position.x, ...children.map((child) => child.position.x)]
  return {
    parentId: node.endpointId,
    parentPosition: node.position,
    branchY: node.position.y + BRANCH_LINE_OFFSET,
    children,
    minX: Math.min(...allXPositions) - BRANCH_PADDING_X,
    maxX: Math.max(...allXPositions) + BRANCH_PADDING_X,
    childCount: node.childCount,
    isCollapsed: node.isCollapsed,
  }
}

export function buildBranchLines(nodes: TreeNode[]): BranchLine[] {
  const childrenByParent = groupChildrenByParent(nodes)
  const branches: BranchLine[] = []
  for (const node of nodes) {
    const children = childrenByParent.get(node.endpointId)
    if (children && children.length > 0) branches.push(buildBranchLine(node, children))
  }
  return branches
}
